import type { FaireProductEntity } from "../../entity_types/product";

export const p_89vxddcvb7: FaireProductEntity = {
  token: "p_89vxddcvb7",
  type: "product",
  name: "Mensch Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b7f77b59edcc9ebebe98813fa660f256f45fd2762aceba9707590f403ef0fdc7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d0dc5342f12280d5c09540983511a6695c2bb789e8067394d1dba71532e1aa3.jpeg",
    "https://cdn.faire.com/fastly/a0a182a6713e926da98824afabee5decd4242f09b3f693932fd6e1ca06f4db9c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/18a870cd3a562276b3d6245c458ba89f3eb6097e7ba73c8b056f24874ba2feb4.jpeg",
    "https://cdn.faire.com/fastly/94000e9e080b6421b66fe5c691275740dfa92735142b57c38ef94a30f1daa49b.jpeg",
    "https://cdn.faire.com/fastly/329cd366db215235f70fed0e2b433e01cc03080a26be58cfcda8d6879bc8885e.jpeg",
    "https://cdn.faire.com/fastly/0670390a04b0d30812a4fe0a05eaeb1338add339660eb59e79b9209bdc925f62.jpeg"
  ],
  priceDollars: 6.75,
  description: "Do you promptly reply to texts? Are you a solid tipper? Have you held a door for someone lately or said \"thank you\" when it wasn't totally required? Then these socks are for you :)\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:58.950Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
